import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-resetpassword',
  templateUrl: './resetpassword.component.html',
  styleUrls: ['./resetpassword.component.css']
})
export class ResetpasswordComponent implements OnInit {
  error: string;
  constructor(public dialogRef: MatDialogRef<ResetpasswordComponent>, @Inject (MAT_DIALOG_DATA) public data: any,
  private authService: AuthService) { }

  ngOnInit() {
  }

  close(){
    this.dialogRef.close();
  }

  passwordChange(password){
    this.authService.changePassword(password.value).subscribe(res=>{
//    console.log("Password Reset");
      this.dialogRef.close();
    },err=>{
      this.error = "Old Password is not correct";
      this.dialogRef.updateSize('600px','300px');
    });
  }

}
